import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import Tag from "../../general/antd/tag";
import RewardContext from "../../../context/rewaed/context";
import { IReward } from "../../../models/reward/response";
import {
  getRewardStatus,
  getRewardStatusColor,
  getRewardType,
  getRewardTypeColor,
} from "../../../models/reward/enum";
import moment from "moment";

interface IProps { }

const RewardTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(RewardContext);

  const columns: ColumnProps<IReward>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("status"),
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_, record) => {
        return (
          <Tag
            title={getRewardStatus(record?.status)}
            color={getRewardStatusColor(record?.status)}
          />
        );
      },
    },
    {
      title: t("type"),
      dataIndex: "type",
      width: 200,
      align: "center",
      key: "type",
      render: (_, record) => {
        return (
          <Tag
            title={getRewardType(record?.type)}
            color={getRewardTypeColor(record?.type)}
          />
        );
      },
    },
    {
      title: t("value"),
      dataIndex: "value",
      align: "center",
      key: "value",
      render: (_, record) => {
        return <>{record?.value ?? "-"}</>;
      },
    },
    {
      title: t("distance"),
      dataIndex: "distance",
      align: "center",
      key: "distance",
      render: (_, record) => {
        return <>{record?.distance ?? "-"}</>;
      },
    },
    {
      title: t("start_datetime"),
      dataIndex: "startDatetime",
      align: "center",
      key: "startDatetime",
      render: (_, record) => {
        return <>{moment(record?.startDatetime).format("YYYY-MM-DD HH:mm:ss") ?? "-"}</>;
      },
    },
    {
      title: t("end_datetime"),
      dataIndex: "endDatetime",
      align: "center",
      key: "endDatetime",
      render: (_, record) => {
        return <>{moment(record?.endDatetime).format("YYYY-MM-DD HH:mm:ss") ?? "-"}</>;
      },
    },

    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      fixed: "right",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
            onClick={(e) => {
              const url = `/rewards/details/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          <EditBtn
            onClick={(e) => {
              const url = `/rewards/update/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />

          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteReward(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        scroll={{
          x: 2100,
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default RewardTable;
